<div class="pme-container">
  <div class="pme-row display-utils-row">
    <div class="pme-col display-utils-gt-sm-flex-50">
      <main>
        <pme-hero *ngIf="this.checkoutSuccessData.modalType == 'processing'" type="warn" title="Estamos processando o seu pedido.">
          <p>
            Não se preocupe, você receberá um email informando se o seu pedido
            foi processado com sucesso ou não.<br />
            Por favor, aguarde.
          </p>
        </pme-hero>

        <pme-hero *ngIf="this.checkoutSuccessData.modalType == 'walletBalance'" type="warn" title="Produto indisponível.">
          <p>
            A promoção é exclusiva para o mesmo pacote da sua última compra. Selecione o {{this.checkoutSuccessData.order.product.name}} na vitrine para seguir. Você poderá escolher um novo pacote quando estiver com crédito abaixo de R${{this.automaticRecharge}}.
          </p>
        </pme-hero>

        <pme-hero *ngIf="this.checkoutSuccessData.modalType == 'alreadyPurchased'" type="warn" title="Você já possui um contrato ativo.">
          <p>
            Para efetuar uma nova compra, é necessário que seu contrato tenha expirado.
          </p>
        </pme-hero>

        <pme-invoice
          *ngIf="this.checkoutSuccessData"
          [bankBilletData]="this.checkoutSuccessData.bankBilletData"
          [pixData]="this.checkoutSuccessData.pixData"
          [creditCardData]="this.checkoutSuccessData.creditCardData"
          [contract]="this.checkoutSuccessData.contract"
          [modalParams]="this.checkoutSuccessData.modalParams"
          >
        </pme-invoice>

        <div class="display-utils-row display-utils-center">
          <a mat-flat-button color="primary" (click)="this.onSuccessClick()" target="_blank">
            {{ this.buttonName }}
          </a>
        </div>

        <br/>

        <div class="display-utils-row display-utils-center" *ngIf="this.checkoutSuccessData.changePaymentUrl && this.checkoutSuccessData.modalType !== 'walletBalance'">
          <a mat-flat-button color="primary" (click)="onSuccessClick()" href="{{ this.checkoutSuccessData.changePaymentUrl }}">
            Alterar forma de pagamento
          </a>
        </div>
      </main>
    </div>
  </div>
</div>
